export const SEARCH_FILE_REFERENCES_FAILURE = 'SEARCH_FILE_REFERENCES_FAILURE';

export const searchFileReferencesFailure = ( payload: Error ) => ({
    type: SEARCH_FILE_REFERENCES_FAILURE,
    payload,
    error: true,
});
